module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/icons/align-right.svg
 ** module id = 71
 ** module chunks = 0
 **/